import { useI18n } from 'context/i18n';
import { useLocale } from './useLocale';
import { useCallback, useMemo } from 'react';

type TPhonePrefix = {
  id: string;
  name: string; // the shape of the prefix is like this "ES (+34)"
};

export function usePhonePrefix() {
  const { profileData } = useI18n();

  const prefixes = useMemo(() => {
    // now we want a simple way to handle getting the prefixes so we need a Map where the key is the id and the value should be the string between parenthesis
    const map = new Map<string, string>();
    if (profileData?.phonePrefixes) {
      profileData.phonePrefixes.forEach((prefix: TPhonePrefix) => {
        map.set(prefix.id, prefix.name);
      });
    }
    return map;
  }, [profileData?.phonePrefixes]);

  const selectPrefixes = useMemo(() => {
    const arr: { value: string; label: string }[] = [];

    for (const [key, value] of prefixes.entries()) {
      arr.push({ value: key, label: value });
    }

    return arr;
  }, [prefixes]);

  const extractPrefix = useCallback(
    ({ countryId, prefix }: { countryId?: string; prefix?: string } = {}) => {
      // Si se proporciona prefix directamente, extraer de esa string
      if (prefix) {
        const match = prefix.match(/\(([^)]+)\)/);
        if (match && match[1]) {
          return match[1];
        }
      }

      // Si se proporciona countryId, buscar en el mapa de prefixes
      if (countryId) {
        const prefixData = prefixes.get(countryId);
        if (prefixData) {
          const match = prefixData.match(/\(([^)]+)\)/);
          if (match && match[1]) {
            return match[1];
          }
        }
      }

      return null;
    },
    [prefixes],
  );

  return {
    selectPrefixes,
    prefixes,
    extractPrefix,
  };
}

